module.exports = __webpack_public_path__ + "files/SPIADI - Affiche Lily.c10aa3167f14bf2707652a7a88029d8b.pdf";